var _rect, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllEmptyAccessSharingOperators(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ill_empty_access_sharing_operators",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 120,
    height: 120,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Illustration",
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#f7f7f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-592.647 -230.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Person",
    transform: "translate(638.935 269.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_315",
    "data-name": "Rectangle 315",
    transform: "translate(0 28.419)",
    fill: "none",
    stroke: "#909090",
    strokeWidth: 4.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0H39.712a8,8,0,0,1,8,8V23.856a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V8A8,8,0,0,1,8,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,2.25H39.712A5.75,5.75,0,0,1,45.462,8V19.356a2.25,2.25,0,0,1-2.25,2.25H4.5a2.25,2.25,0,0,1-2.25-2.25V8A5.75,5.75,0,0,1,8,2.25Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M22531.227-5553.5h0a.76.76,0,0,0-.234-.021h-.492a12.925,12.925,0,0,1-8.82-3.76,12.277,12.277,0,0,1-3.531-8.656,12.468,12.468,0,0,1,12.461-12.439,12.453,12.453,0,0,1,12.438,12.439,12.466,12.466,0,0,1-11.82,12.438Zm-.57-4.486h0a1.159,1.159,0,0,1,.148.01l.023,0c.047,0,.078.008.117.008l.07.021.07-.021a8.047,8.047,0,0,0,7.555-7.994,8.025,8.025,0,0,0-8.031-8.016,8.015,8.015,0,0,0-8.008,8.016,7.98,7.98,0,0,0,7.688,7.994l.344.021.023-.041Z",
    transform: "translate(-22506.74 5578.378)",
    fill: "#909090"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Person-2",
    "data-name": "Person",
    transform: "translate(618.646 260.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M23271.457-5369.026h-.625a9.148,9.148,0,0,1-8.836-9.1,9.157,9.157,0,0,1,9.117-9.15,9.142,9.142,0,0,1,9.141,9.115,9.113,9.113,0,0,1-8.781,9.131Zm-.25-3.373c.125,0,.2.021.25.021h.086l.055.016h.07a5.727,5.727,0,0,0,5.281-5.777,5.757,5.757,0,0,0-5.773-5.74,5.738,5.738,0,0,0-5.734,5.74,5.791,5.791,0,0,0,5.43,5.777h.164v-.037Z",
    transform: "translate(-23252.865 5387.272)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M23154.359-5296.428h15.031s2.664.145,2.617-2.027-2.617-1.877-2.617-1.877h-11.125v-3.678a5.832,5.832,0,0,1,5.828-5.826h12.7a1.943,1.943,0,0,0,1.563-2.016,1.748,1.748,0,0,0-1.562-1.889h-12.7a9.744,9.744,0,0,0-9.734,9.73v7.582Z",
    transform: "translate(-23154.359 5335.56)",
    fill: "#909090"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllEmptyAccessSharingOperators);
export default __webpack_public_path__ + "static/media/ill_empty_access_sharing_operators.a4e80c5ce6a72fc429f0010e23668b1d.svg";
export { ForwardRef as ReactComponent };